require('normalize.css/normalize.css');
require('styles/App.css');
//require('scss/app.scss');
import 'scss/app.scss';

import React from 'react';
import 'weui';
import RaceList from './RaceList'

class AppComponent extends React.Component {
  render() {
    return (
      <div className="index">
        <RaceList />
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



/** WEBPACK FOOTER **
 ** ./src/components/Main.js
 **/